import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Positioning", desc: "Sharper market positioning and narrative clarity so the business is understood quickly and correctly." },
  { title: "Messaging Systems", desc: "Taglines, headlines, proof frameworks, and tone rules that make marketing and sales more consistent." },
  { title: "Visual Identity", desc: "Logo direction, typography, palette, and brand structure that feel premium and usable in practice." },
  { title: "Brand Collateral", desc: "Core presentation, social, and launch assets so the identity actually travels across touchpoints." },
  { title: "Guidelines", desc: "A practical brand guide your team can follow without turning every asset into a debate." },
  { title: "Go-To-Market Assets", desc: "Landing page direction, deck support, and rollout assets aligned to the new brand system." },
];

const Branding = () => (
  <StitchFeaturePage
    label="BRANDING & VISUAL IDENTITY"
    title="Brands that feel"
    titleAccent="intentional."
    subtitle="Positioning, messaging, and visual systems for teams that want clarity, authority, and a stronger first impression."
    features={features}
    ctaLabel="START A BRAND ENGAGEMENT"
  />
);

export default Branding;
